import React from 'react';
import { connect } from 'react-redux'
import HeaderContainer from '../containers/HeaderContainer';
import cn from 'classnames';

const mapStateToProps = (state) => {
    return {
        loading: state.user.loading,
        authorized: state.user.authorized
    };
};

const AuthorizedPage = ({children, authorized, loading, dark}) => {
    
    if(!authorized && loading){
        return (<div style={{textAlign:'center',marginTop:'1rem'}}>Initializing...</div>)
    }
    if (!authorized) {
        location.href="/";
        return null;
    }

    return (
        <div className={cn(dark?'dark':null, 'AuthorizedPage')}>
            <HeaderContainer />
            {children}
        </div>
    );
};

export default connect(mapStateToProps)(AuthorizedPage);



// WEBPACK FOOTER //
// ./src/pages/AuthorizedPage.js